// `/preview/**` is public only as the TRAVELLER link.
//
// A preview URL renders one of two things depending on `?view`: the
// traveller's read-only trip, or the agent view — Edit toggle, Planner
// deep-link back into the editor, Budget Breakdown, optional-item prices.
// Legacy gated that in `proxy.ts`: `auth.protect()` ran on every route outside
// the public list, and `/preview` escaped it ONLY with the traveller flag, so a
// signed-out visitor holding an itinerary id could never reach consultant
// chrome.
//
// Both accepted values mirror the rest of the preview domain: `traveller` is
// canonical, `customer` is the permanent alias that share / WhatsApp / embed
// links still carry (see `@preview/shared/lib/preserve-preview-view`).
//
// Enforced at two layers, both calling this: the route's `beforeLoad`
// (`apps/web/src/app/routes/preview.ts` — redirects before anything renders)
// and `AuthGuard` (component-level backstop). The `/pv/` short alias stays
// unconditionally public: it resolves the id and redirects into `/preview`
// with the traveller flag, so it lands back on this rule.
const PREVIEW_PATH_PREFIX = '/preview';

export const isTravellerPreviewLink = (
  pathname: string,
  search: { view?: unknown } | undefined
): boolean =>
  pathname.startsWith(PREVIEW_PATH_PREFIX) &&
  (search?.view === 'traveller' || search?.view === 'customer');
